
import Vue from "vue";
import { LabelLayoutModel } from "@/models/label-layout/label-layout-model";
import { EpsonSettings } from "@/utils/label-layout/epson-settings";
import { EpsonPrint } from "@/utils/electron/electron-print-epson";

export default Vue.extend({
	data(){
		return {
			status: "",
			hasError: false,
			ready: false,
			printed: 0,
			messageHandler: null as null | ((event:MessageEvent)=>void)
		};
	},
	props: {
		layout: {
			type: Object as ()=>LabelLayoutModel,
			required: true
		},
		records: {
			type: Array as ()=>any[],
			required: true
		},
		copies: {
			type: Number,
			default: 1
		}
	},
	computed: {
		settings():EpsonSettings {
			return this.layout.Data?.Data.Epson || new EpsonSettings();
		},
		serviceOrigin():string {
			return this.settings.getServiceOrigin();
		},
		iframeUrl():string {
			if (!this.serviceOrigin) return "";
			return `${this.serviceOrigin}/label/${encodeURIComponent(this.settings.Template)}`;
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		postToFrame(message:any){
			let frame = this.$refs.frame as HTMLIFrameElement | undefined;
			if (!frame || !frame.contentWindow) return;
			frame.contentWindow.postMessage(message, this.serviceOrigin);
		},
		sendInit(){
			let data = this.records.map(r=>EpsonPrint.buildData(this.settings, r));
			this.postToFrame({
				type: "label:init",
				records: data,
				copies: this.copies,
				quality: this.settings.Quality
			});
		},
		async onMessage(event:MessageEvent){
			if (event.origin != this.serviceOrigin) return;
			let msg = event.data;
			if (!msg || typeof msg.type != "string") return;
			if (msg.type == "label:ready") {
				this.ready = true;
				this.sendInit();
			} else if (msg.type == "label:job") {
				await this.printJob(msg);
			} else if (msg.type == "label:done") {
				this.hasError = false;
				this.status = this.$ct("epson-done", {count: this.printed}) as string;
			} else if (msg.type == "label:error") {
				this.hasError = true;
				this.status = `${msg.message || "Onbekende fout"}`;
			} else if (msg.type == "label:close") {
				this.close();
			}
		},
		async printJob(msg:any){
			try {
				await EpsonPrint.sendJob(msg.job as ArrayBuffer, this.settings);
				this.printed++;
				this.hasError = false;
				this.status = this.$ct("epson-sent", {index: (msg.index || 0) + 1, total: msg.total || 1}) as string;
			} catch (err:any) {
				this.hasError = true;
				let detail = err?.response?.data?.error || err?.message || `${err}`;
				this.status = this.$ct("epson-error", {error: detail}) as string;
			}
		}
	},
	mounted(){
		this.messageHandler = (event:MessageEvent)=>this.onMessage(event);
		window.addEventListener("message", this.messageHandler);
	},
	beforeDestroy(){
		if (this.messageHandler) {
			window.removeEventListener("message", this.messageHandler);
		}
	},
	i18nEx: {
		componentPrefix: "components.browse"
	}
});
